const Section4 = () => {
  const Cards = ({item}) => {
    return (
      <div className="lg:w-[30%]  p-5 rounded-lg shadow-xl border flex justify-center items-center">
        <span className="font-bold text-xs lg:text-base">{item}</span>
      </div>
    );
  };

  const cardscontent =[
    "Single Program:  $150","All 4 Programs:  $500","3 Months : Trial"
    ,"Access to Updates","Full Source code","Support: 6 Months"
  ]

  return (
    <section className=" flex flex-col justify-center gap-y-5 lg:mt-8 ">
      <h1 className="flex justify-center items-center text-xl lg:text-2xl font-bold mb-5">How to Use the program</h1>
      <p className="px-5 lg:px-64 text-center text-sm lg:text-base mb-5">
        Given most teachers’ knowledge of IT is rudimentary, Would <br/>“This
        allows you to download the Programs onto your Server, have full control
        to customise and maintain the Program according to your educational and
        specific requirements.”
      </p>

      <div className="flex flex-wrap gap-5 lg:px-64 items-center justify-center shrink-0 mb-5 ">
        {cardscontent.map(item => <Cards item={item} />)}
        
      </div>

      <h3 className="lg:px-64 px-5 text-center text-sm lg:text-base">
        This allows you full control to customize, deploy, and maintain the
        program according to your specific educational or technical
        requirements.
      </h3>
    </section>
  );
};

export default Section4;
